// src/ui/GroupList.tsx

import React from 'react';
import type { PartGroup } from '../types';

interface GroupListProps {
  groups: PartGroup[];
  currentGroupId: string | null;
  onSelectGroup: (groupId: string) => void;
}

export const GroupList: React.FC<GroupListProps> = ({ 
  groups, 
  currentGroupId, 
  onSelectGroup 
}) => {
  return (
    <div className="group-list">
      <h3>Part Groups</h3>
      <div className="groups-container">
        {groups.length === 0 ? (
          <p className="no-groups">No groups available</p>
        ) : (
          groups.map((group) => {
            const isActive = group.id === currentGroupId;
            const progress = group.count > 0 
              ? Math.round((group.placedCount / group.count) * 100) 
              : 0;
            
            return (
              <div
                key={group.id}
                className={`group-item ${isActive ? 'active' : ''}`}
                onClick={() => onSelectGroup(group.id)}
              >
                <div className="group-header">
                  <span className="group-name">
                    {group.mpn || group.value || group.description || 'Unknown Part'}
                  </span>
                  <span className="group-count">
                    {group.placedCount}/{group.count}
                  </span>
                </div>
                
                <div className="group-details">
                  {group.footprint && (
                    <span className="footprint">{group.footprint}</span>
                  )}
                  {group.manufacturer && (
                    <span className="manufacturer">{group.manufacturer}</span>
                  )}
                </div>
                
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};
